import { createSlice } from '@reduxjs/toolkit'
import reducers from 'store/features/project/reducers'
import { getInitialState } from 'store/features/project/initialState'

const projectSlice = createSlice({
  name: 'project',
  initialState: getInitialState(),
  reducers
})

export default projectSlice
